import { del, EndPoints, get, patch, post } from '../';
export function list() {
    return get(EndPoints.users, { all: 1 });
}
export function createUser(request) {
    return post(EndPoints.usersCreate, request);
}
export function updateUser(request) {
    return patch(EndPoints.usersUpdate, request);
}
export function deleteUser(request) {
    return del(EndPoints.usersDelete, request);
}
